import { InputNumber } from 'antd';
import { normalizeDecimalString } from '../utils/numberUtils';

/**
 * Global parser so InputNumber accepts both comma and dot as decimal separators
 * and ignores thousands separators/spaces.
 */
const InputNumberAny = InputNumber as any;
InputNumberAny.defaultProps = {
  ...(InputNumberAny.defaultProps || {}),
  parser: normalizeDecimalString,
};

export {}; // side-effect only


